import React, {
	useCallback, useEffect, useMemo, useRef, useState,
} from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import useContain from 'react-contain-textbox';
import { useFirestoreCollectionRT } from '../hooks/firebase';
import useToasty from '../hooks/toasty';
import useFirework from '../hooks/firework';
import ItemCard from './ItemCard';

const useStyles = makeStyles((theme) => ({
	root: {
		whiteSpace: 'nowrap',
		alignItems: 'center',
	},
	card: {
		display: 'inline-block',
		marginLeft: theme.spacing(1),
	},
	cardColumn: {
		display: 'block',
		marginBottom: theme.spacing(1),
	},
}));

function donationSort([, a], [, b]) {
	return b.createdDateUTC > a.createdDateUTC ? 1 : -1;
}

export default function Ticker(props) {
	const { className, asColumn } = props;

	const classes = useStyles();

	const ref = useRef();
	const resize = useContain(ref);

	const teams = useFirestoreCollectionRT('teams');

	const donations = useFirestoreCollectionRT(
		'donations',
		useMemo(() => ({ orderBy: ['createdDateUTC', 'desc'], limit: 10 }), []),
	);

	useEffect(() => {
		resize();
	}, [resize, donations]);

	const doToasty = useToasty();
	const doFirework = useFirework();

	const handleDonation = useCallback((amount) => {
		doToasty();

		const limit = Math.floor(amount ** (1 / 3));
		for (let i = 0; i < limit; i += 1) {
			doFirework(i * 200);
		}
	}, [doToasty, doFirework]);

	const staleDonations = useMemo(() => ([]), []);
	const [donationReady, setDonationReady] = useState(false);
	useEffect(() => {
		if (!donations) return;

		const donationKeys = Object.keys(donations);
		const keys = donationKeys.filter((k) => !staleDonations.includes(k));
		staleDonations.push(...keys);

		if (!donationReady) {
			setDonationReady(true);
			return;
		}
		if (keys.length < 1) return;

		const amount = keys.reduce((total, key) => (donations[key].amount || 1) + total, 0);

		handleDonation(amount);
	}, [donations, staleDonations, donationReady, handleDonation]);

	return (
		<div
			ref={ref}
			className={clsx(classes.root, className)}
		>
			{donations && Object.entries(donations).sort(donationSort).map(([donationId, donation]) => (
				donation && !donation.hidden && (
					<ItemCard
						key={donationId}
						className={asColumn ? classes.cardColumn : classes.card}
						avatarUrl={teams[donation.teamID]?.avatarImageURL}
						title={`${donation.displayName || 'Anonymous Human'}`}
						body={`$${donation.amount.toFixed(2)} => ${donation.recipientName}`}
					/>
				)
			))}
		</div>
	);
}

Ticker.defaultProps = {
	className: undefined,
	asColumn: false,
};

Ticker.propTypes = {
	className: propTypes.string,
	asColumn: propTypes.bool,
};
